import { useNavigate } from 'react-router'
import { useAuth } from '../contexts/AuthContext'
import { MfaTab } from './SettingsPage'
import { colors, fontSize, radius, shadow, spacing } from '../styles/theme'

/**
 * Where the SPA lands when the API answers 403 mfa_required: an admin past the MFA deadline can only
 * reach /auth endpoints, so this page uses nothing else — enroll, then continue, or sign out.
 */
export default function MfaRequiredPage() {
  const { logout, user, refresh } = useAuth()
  const navigate = useNavigate()

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: colors.background, padding: spacing.md,
    }}>
      <div style={{
        background: colors.surface, borderRadius: radius.lg, boxShadow: shadow.lg,
        padding: spacing.xl, width: '100%', maxWidth: 520,
      }}>
        <h1 style={{ fontSize: fontSize.xl, fontWeight: 700, color: colors.text, marginBottom: spacing.sm }}>
          Two-factor authentication required
        </h1>
        <p style={{ fontSize: fontSize.sm, color: colors.textSecondary, marginBottom: spacing.lg }}>
          {user?.isAuditor ? 'Auditor' : 'Admin'} accounts must use two-factor authentication. Enable it below to continue.
        </p>
        <MfaTab />
        <div style={{ display: 'flex', gap: spacing.md, marginTop: spacing.lg }}>
          <button onClick={async () => { await refresh(); navigate(user?.isAuditor ? '/audit' : '/app/dashboard') }}
            style={{ padding: `${spacing.sm} ${spacing.md}`, background: colors.primary, color: '#fff', border: 'none', borderRadius: radius.sm, cursor: 'pointer' }}>
            Continue
          </button>
          <button onClick={async () => { await logout(); navigate('/login') }}
            style={{ padding: `${spacing.sm} ${spacing.md}`, background: 'transparent', color: colors.textSecondary, border: `1px solid ${colors.border}`, borderRadius: radius.sm, cursor: 'pointer' }}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  )
}
